<template>
  <div class="card">
    <div class="row">
      <h2>Outgoing</h2>
      <div class="grow"></div>
      <button class="btn" :disabled="posting" @click="submit">
        {{ posting ? 'Saving…' : 'Post Transaction' }}
      </button>
    </div>

    <div v-if="err" class="err">{{ err }}</div>
    <div v-if="ok" class="ok">{{ ok }}</div>

    <div class="grid">
      <label>
        <div class="lbl">Type</div>
        <select class="input" v-model="direction">
          <option value="OUT">OUT (issue material)</option>
          <option value="ADJUST">ADJUST (+/- correction)</option>
        </select>
      </label>

      <label>
        <div class="lbl">Material</div>
        <select class="input" v-model="materialSku" @change="syncUnit">
          <option value="">Select material</option>
          <option v-for="m in materials" :key="m.sku" :value="m.sku">
            {{ m.sku }} — {{ m.name }}
          </option>
        </select>
      </label>

      <label>
        <div class="lbl">Unit</div>
        <input class="input" v-model="unit" placeholder="e.g. sqft" />
      </label>

      <label>
        <div class="lbl">Qty</div>
        <input class="input" v-model="qty" type="number" step="0.01" />
        <div class="helper" style="margin-top:6px;">
          OUT must be positive. ADJUST can be negative or positive.
        </div>
      </label>

      <label>
        <div class="lbl">Ref Type</div>
        <select class="input" v-model="refType">
          <option value="NONE">NONE</option>
          <option value="ORDER">ORDER</option>
        </select>
      </label>

      <label v-if="refType === 'ORDER'">
        <div class="lbl">Order ID</div>
        <input class="input" v-model="refId" type="number" />
      </label>

      <label class="span2">
        <div class="lbl">Note (optional)</div>
        <input class="input" v-model="note" />
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RmOutgoing',
  data () {
    return {
      direction: 'OUT',
      materialSku: '',
      unit: '',
      qty: '',
      refType: 'NONE',
      refId: '',
      note: '',
      ok: ''
    }
  },
  computed: {
    materials () { return this.$store.getters['inventory/materials'] },
    posting () { return !!this.$store.state.inventory.posting },
    err () { return this.$store.state.inventory.lastError }
  },
  methods: {
    syncUnit () {
      const m = (this.materials || []).find(x => x.sku === this.materialSku)
      if (m && !this.unit) this.unit = m.unit || ''
    },
    n (v) {
      if (v === '' || v === null || v === undefined) return null
      const x = Number(v)
      return Number.isFinite(x) ? x : null
    },
    async submit () {
      this.ok = ''
      const sku = (this.materialSku || '').trim()
      const unit = (this.unit || '').trim()
      const qty = this.n(this.qty)

      if (!sku || !unit || qty === null) {
        this.$store.commit('inventory/setError', 'Material, Unit and Qty are required.')
        return
      }

      if (this.direction === 'OUT' && qty <= 0) {
        this.$store.commit('inventory/setError', 'OUT qty must be positive.')
        return
      }
      if (this.direction === 'ADJUST' && qty === 0) {
        this.$store.commit('inventory/setError', 'ADJUST qty cannot be zero.')
        return
      }

      let rid = null
      if (this.refType === 'ORDER') {
        rid = this.n(this.refId)
        if (!rid || rid <= 0) {
          this.$store.commit('inventory/setError', 'Order ID must be a number.')
          return
        }
      }

      const payload = {
        direction: this.direction,
        materialSku: sku,     // backend accepts sku OR materialSku
        qty: qty,
        unit: unit,
        refType: this.refType,
        refId: rid,
        note: (this.note || '').trim() || null
      }

      const ok = await this.$store.dispatch('inventory/createTxn', payload)
      if (ok) {
        this.ok = 'Transaction posted.'
        this.materialSku = ''
        this.unit = ''
        this.qty = ''
        this.refType = 'NONE'
        this.refId = ''
        this.note = ''
      }
    }
  },
  async mounted () {
    await this.$store.dispatch('inventory/loadMasters')
  }
}
</script>

<style scoped>
.row{ display:flex; align-items:center; gap:10px; margin-bottom:10px; }
.grow{ flex:1; }
.grid{ display:grid; grid-template-columns: 1fr 1fr 1fr; gap:12px; margin-top:10px; }
.lbl{ font-weight:700; font-size:12px; color:#6b7280; margin-bottom:6px; }
.span2{ grid-column: span 2; }
.err{ color:#b91c1c; margin:8px 0; }
.ok{ color:#15803d; margin:8px 0; font-weight:700; }
.helper{ color:#6b7280; font-size:12px; }
@media (max-width: 980px){ .grid{ grid-template-columns:1fr 1fr; } .span2{ grid-column: span 2; } }
@media (max-width: 640px){ .grid{ grid-template-columns:1fr; } .span2{ grid-column: span 1; } }
</style>
